"use client"
import type { ActivityFeedTableView } from "@opensea/navigation"
import { Button } from "@opensea/next-ui-kit"
import {
  Media,
  ToggleButtonGroup,
  ToggleButtonGroupItem,
  Tooltip,
} from "@opensea/ui-kit"
import { TableRows, TableRowsNarrow } from "@opensea/ui-kit/icons"
import { useTranslations } from "next-intl"
import { useActivityFeedTableView } from "./ActivityFeedTableViewProvider"

const VIEWS = [
  { tableView: "table", icon: TableRows },
  { tableView: "tableCompact", icon: TableRowsNarrow },
] as const satisfies {
  tableView: ActivityFeedTableView
  icon: React.ComponentType
}[]

export function ActivityFeedTableViewToggle() {
  const { tableView, setTableView } = useActivityFeedTableView()
  const t = useTranslations("ActivityFeedTableViewToggle")
  const iconIndex = Math.max(
    VIEWS.findIndex(
      ({ tableView: iconTableView }) => iconTableView === tableView,
    ),
    0,
  )

  return (
    <>
      <Media lessThan="lg">
        <Button
          icon={VIEWS[iconIndex].icon}
          onClick={() => {
            const nextIndex = (iconIndex + 1) % VIEWS.length
            setTableView(VIEWS[nextIndex].tableView)
          }}
          size="sm"
          variant="secondary"
        />
      </Media>
      <Media greaterThanOrEqual="lg">
        <ToggleButtonGroup
          onValueChange={setTableView}
          value={tableView}
          variant="secondary-transparent"
        >
          <Tooltip content={t("table")}>
            <span className="w-full">
              <ToggleButtonGroupItem icon={TableRows} value="table" />
            </span>
          </Tooltip>
          <Tooltip content={t("compactTable")}>
            <span className="w-full">
              <ToggleButtonGroupItem
                icon={TableRowsNarrow}
                value="tableCompact"
              />
            </span>
          </Tooltip>
        </ToggleButtonGroup>
      </Media>
    </>
  )
}
